import React from 'react';
import PropTypes from 'prop-types';

import ExternalLink from 'components/Widgets/ExternalLink';

import ReactPlayer from 'react-player/vimeo';

export default function Header({ resource }) {
  return (
    <section>
      <div className="d-md-flex gap-4 justify-content-between">
        <div className="mb-3">
          <h1 className="mb-3">
            {resource
              ? resource.attributes.title
              : "Welcome To LeggUP's Ultimate Leadership Resource Hub."}
          </h1>
          <p className="mb-3">
            {resource ? resource.attributes.description
              : 'Empower Your Teams with LeggUP: Everything You Need to Kickstart a Transformative Leadership Program!'}
          </p>
          <ExternalLink href="https://benefits.leggup.com/meetings/tom-finn/talent-consultation-45">
            Contact Sales
          </ExternalLink>
        </div>
        {resource && resource.attributes.vimeo !== '' && (
          <div>
            <ReactPlayer
              url={resource.attributes.vimeo}
              controls
              className="resource-video-promote"
              style={{
                borderRadius: '20px', overflow: 'hidden', width: '100%', height: '100%',
              }}
            />

          </div>
        )}
      </div>
    </section>
  );
}

Header.propTypes = {
  resource: PropTypes.object,
};

Header.defaultProps = {
  resource: null,
};
